import { render, staticRenderFns } from "./PxAvisoPlataformaFornecedorSimple.vue?vue&type=template&id=fb1d12da"
import script from "./PxAvisoPlataformaFornecedorSimple.vue?vue&type=script&lang=js"
export * from "./PxAvisoPlataformaFornecedorSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports